import useLanguage from '@/utils/hooks/useLanguage';
import { Tab } from '@headlessui/react';
import cn from 'classnames';
import { ReactNode } from 'react';

export enum MarketListFilter {
    'All' = 0,
    'FX' = 1,
    'Crypto' = 2,
    'Index and Comm CFDs' = 3
}

interface ModuleTabsProps {
    tabs: string[];
    className?: string;
}

interface ModuleTabsListProps {
    className?: string;
    children: ReactNode;
}

interface ModuleTabsChildProps {
    className?: string;
    children: ReactNode;
}

const ModuleTabs = {
    Main: ({ tabs, className }: ModuleTabsProps) => {
        return (
            <ModuleTabs.List className={className}>
                {tabs.map((tab) => (
                    <ModuleTabs.Child key={tab}>{tab}</ModuleTabs.Child>
                ))}
            </ModuleTabs.List>
        );
    },
    List: ({ className, children }: ModuleTabsListProps) => {
        const lang = useLanguage();
        return (
            <Tab.List
                className={cn(
                    'flex bg-brand-background border-b-[1px] border-b-brand-neutral-700 w-full overflow-x-auto overflow-y-hidden p-1 gap-1',
                    className
                )}
                dir={lang.dir}>
                {children}
            </Tab.List>
        );
    },
    Child: ({ className, children }: ModuleTabsChildProps) => {
        return (
            <Tab
                className={({ selected }) =>
                    cn(
                        'p-1 px-2 text-sm font-medium leading-none h-[29px] text-brand-text focus:outline-none whitespace-nowrap rounded-sm',
                        {
                            'bg-brand-primary text-brand-module-title': selected,
                            [`text-brand-neutral-400 hover:bg-brand-neutral-700 hover:text-brand-text ${className}`]:
                                !selected
                        }
                    )
                }>
                {children}
            </Tab>
        );
    }
};

export default ModuleTabs;
